import React from "react";
import { useLang } from "@/context/LanguageContext";
import SymbolPage from "@/components/SymbolPage";

const IMG = "https://images.unsplash.com/photo-1538998073820-4dfa76300194?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600";

const Udsatte = () => {
  const { t } = useLang();
  return <SymbolPage data={t.udsatte} image={IMG} />;
};

export default Udsatte;
